import Vue from 'vue'
import App from './App.vue'
import router from './router/router'
import store from './store/store'
import vuetify from './plugins/vuetify'
import IdleVue from 'idle-vue'
import Tinymce from 'tinymce'
//Axios plugin
import './plugins/axios'

// Import the Auth0 configuration
import { domain, clientId, audience } from '../auth_config.json'
// Import auth0 plugin here
import { Auth0Plugin } from './auth'
// Install the authentication plugin here
Vue.use(Auth0Plugin, {
    domain,
    clientId,
    audience,
    onRedirectCallback: appState => {
        router.push(
            appState && appState.targetUrl
                ? appState.targetUrl
                : window.location.pathname
        )
    }
})

const eventsHub = new Vue()

Vue.use(IdleVue, {
    eventEmitter: eventsHub,
    store,
    idleTime: 300000, // 5 minutes until idle starts, utilService counts for 15 minutes before idle prompt to user
    startAtIdle: false
})

Vue.use(Tinymce)

Vue.config.productionTip = false

new Vue({
    router,
    store,
    vuetify,
    render: h => h(App)
}).$mount('#app')
